import { Contact } from "@deathstar/types/northstar";
import { QueryKey, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { blazar } from "../util/blazar";
import { ResponseError } from "../util/exceptions";

export const contacts = {
    queryKeys: {
        getById: (accountId: string) => ["contacts", accountId] as QueryKey,
    },

    getById: (accountId: string) => {
        return blazar.fetchJson<Contact[]>(`waypoint/orgs/${accountId}/contacts`);
    },

    useById: <T = Contact>(accountId: string, config?: Partial<UseQueryOptions<Contact[], ResponseError, T[]>>) =>
        useQuery({
            queryKey: contacts.queryKeys.getById(accountId),
            queryFn: () => contacts.getById(accountId),
            staleTime: 30_000,
            ...config,
        }),
};
